import {
  buildEventsFilter
} from '@utils/events'
import { useModuleContext } from '../../contexts/EventsContext'
import usePush from '../../hooks/usePush'
import { Dropdown } from '@mch-group/uikit-components'

const selectItem = {
  key: 'code',
  value: 'code',
  text: 'value',
  id: 'code',
  name: 'value',
  disabled: 'count'
}

const SortBy = () => {
  //@ts-ignore
  const [{ labels, router }] = useModuleContext()

  const routerQuery = router.query
  const { pushChange } = usePush()

  return (
    <Dropdown
      className='mb-9 mb-md-10 mb-lg-0 mb-xl-0 mb-xxl-0'
      label=''
      value={routerQuery.orderBy || 'endDate ASC,startDate ASC'}
      options={buildEventsFilter(
        [
          { code: 'endDate ASC,startDate ASC', value: labels.Events.browseFilterEndDate },
          { code: 'startDate ASC,endDate ASC', value: labels.Events.browseFilterStartDate },
          { code: 'dateCreated DESC', value: labels.Events.browseFilterRecentlyAdded }
        ],
        selectItem, labels.Events.browseFilterAll, false)}
      onChange={(value) => {
        pushChange(value, 'orderBy')
      }}
      onVisibilityChange={() => { }}
    />
  )
}

export default SortBy
